// extracted by mini-css-extract-plugin
module.exports = {"topSpace":"Home_topSpace_3nJNq"};